// eslint-disable-next-line
// @ts-nocheck
import prepareFormNode from './formHelper';

const showItemInFrame = (frame) => {
	if (!frame) {
		return;
	}

	const currentItem = window.item;
	const currentItemType = currentItem.getAttribute('type');
	const formMode = window.isNew ? 'add' : window.isEditMode ? 'edit' : 'view';
	let formNode = aras.uiGetForm4ItemEx(currentItem, formMode);
	formNode = prepareFormNode(formNode, currentItemType);

	aras.uiShowItemInFrameEx(
		frame.contentWindow,
		currentItem,
		formMode,
		0,
		formNode
	);
};
export default class Form extends HyperHTMLElement {
	created() {
		this.style.height = window.formHeight + 'px';
		this.html`
			<iframe
				id="instance" frameborder="0" width="100%" height="100%"
				onconnected="${() => this.render()}"
				onload="${(e) =>
					window.returnBlockerHelper.attachBlocker(e.target.contentWindow)}"
			></iframe>
		`;
	}

	async render() {
		if (this.renderPromise) {
			return this.renderPromise;
		}

		this.renderPromise = Promise.resolve();
		await this.renderPromise;
		showItemInFrame(this.firstElementChild);
		this.renderPromise = null;
	}
}
